import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import BannerImage from "../assets/pizza.jpeg";
import PepperoniImg from "../assets/pepperoni.jpg";
import MargheritaImg from "../assets/margherita.jpg";
import VeggietaImg from "../assets/pizza.jpeg";
import "../styles/Home.css";
import { motion } from "framer-motion";

// Animation variant for bar-style entrance
const barVariant = {
  hidden: { width: 0, y: 30, scale: 0.95 },
  visible: {
    width: "100%", // Changed from 100vw to 100% for better responsiveness
    y: 0,
    scale: 1,
    transition: {
      duration: 0.6,
      ease: [0.25, 0.8, 0.25, 1],
    },
  },
  exit: {
    x: typeof window !== "undefined" ? window.innerWidth : 0, // Safe check for SSR
    y: -20,
    scale: 0.95,
    transition: {
      duration: 0.5,
      ease: "easeInOut",
    },
  },
};

function Home() {
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 0
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <motion.div className="home" initial="hidden" animate="visible" exit="exit">
      {/* Hero Section */}
      <motion.div
        className="hero"
        style={{ backgroundImage: `url(${BannerImage})` }}
        variants={barVariant}
      >
        <div className="overlay">
          <div className="headerContainer">
            <h1>Pedro's Pizzeria</h1>
            <p>Pizza to Fit Any Taste</p>
            <Link to="/menu">
              <button className="button">ORDER NOW</button>
            </Link>
          </div>
        </div>
      </motion.div>

      {/* Features Section */}
      <motion.section className="features" variants={barVariant}>
        <h2>Why Choose Us?</h2>
        <div className="featureCards">
          <div className="card">
            <h3>🍕 Authentic Recipes</h3>
            <p>Traditional Italian flavors made fresh every day.</p>
          </div>
          <div className="card">
            <h3>🚚 Fast Delivery</h3>
            <p>Hot, delicious pizza delivered to your door in minutes.</p>
          </div>
          <div className="card">
            <h3>💖 Customer Favorite</h3>
            <p>Loved by thousands of pizza lovers in town.</p>
          </div>
        </div>
      </motion.section>

      {/* Signature Pizzas */}
      <motion.section className="signature" variants={barVariant}>
        <h2>Our Signature Pizzas</h2>
        <div className="dishes">
          <div className="dish">
            <img src={PepperoniImg} alt="Pepperoni Supreme" />
            <h4>Pepperoni Supreme</h4>
          </div>
          <div className="dish">
            <img src={MargheritaImg} alt="Classic Margherita" />
            <h4>Classic Margherita</h4>
          </div>
          <div className="dish">
            <img src={VeggietaImg} alt="Veggie Delight" />
            <h4>Veggie Delight</h4>
          </div>
        </div>
      </motion.section>

      {/* Testimonials Section */}
      <motion.section className="testimonials" variants={barVariant}>
        <h2>What Our Customers Say</h2>
        <div className="testimonialCards">
          <blockquote>"Best pizza in town, hands down!" – Sarah J.</blockquote>
          <blockquote>"The crust is to die for. Perfect every time." – Tom B.</blockquote>
          <blockquote>"My go-to place for a cozy night in!" – Mia K.</blockquote>
        </div>
      </motion.section>
    </motion.div>
  );
}

export default Home;
